export class TokenValidator {
    isValid(token) {
        if (!this.canValidate(token.header)) {
            return false;
        }
        if (!this.isSignatureValid(token)) {
            return false;
        }
        if (this.isExpired(token)) {
            return false;
        }
        return this.performExtraValidation(token);
    }
    performExtraValidation(token) {
        return true;
    }
    isExpired(token) {
        const nowUtcSeconds = new Date().getTime() / 1000;
        const delta = 30;
        return nowUtcSeconds + delta > token.body.exp;
    }
}
//# sourceMappingURL=token-validator.js.map